import ContactsStep from "./ContactsStep";
import InformationStep from "./Information";
import UsageStep from "./Usage";
import ExtrasStep from "./Extras";
import PreviewStep from "./PreviewStep";
import { contactsFormSchema, extrasFormSchema, informationFormSchema, usageFormSchema } from "../schema";

const steps = [
  { name: 'contacts', title: 'Contacts', icon: 'far fa-address-card text-white fs-1' },
  { name: 'info', title: 'Info', icon: 'fas fa-user-tag text-white fs-1' },
  { name: 'usage', title: 'Usage', icon: 'fas fa-file-export text-white fs-1' },
  { name: 'extras', title: 'Extras', icon: 'fas fa-cookie-bite text-white fs-1',},
  { name: 'preview', title: 'Preview', icon: 'far fa-check-circle text-white fs-1'},
]

export const getStepComponentByName = name => {
  switch(name) {
    case 'contacts':
      return ContactsStep;
    case 'info':
      return InformationStep;
    case 'usage':
      return UsageStep;
    case 'extras':
      return ExtrasStep;
    case 'preview':
      return PreviewStep;
    default:
      return ContactsStep;
  }
}

export const getStoreKeyByName = name => {
  switch(name) {
    case 'contacts':
      return 'contactsFormValue';
    case 'info':
      return 'informationFormValue';
    case 'usage':
      return 'usageFormValue';
    case 'extras':
      return 'extrasFormValue';
    case 'preview':
      return null
    default:
      return null;
  }
}

export const getSchemaByName = name => {
  switch(name) {
    case 'contacts':
      return contactsFormSchema;
    case 'info':
      return informationFormSchema;
    case 'usage':
      return usageFormSchema;
    case 'extras':
      return extrasFormSchema;
    case 'preview':
      return null
    default:
      return null;
  }
}

export default steps;